import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
// MODELS
import { DialogConfirm } from '@models/dialogs/DialogConfirm';

@Component({
  selector: 'ui-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss']
})
export class UIConfirmDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<UIConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogConfirm
  ){
    this.data = {
      title: data?.title || "¿Estás seguro?",
      message: data?.message || "¡Esta operación no se podrá revertir!",
      titleConfirmButton: data?.titleConfirmButton || "Sí, estoy seguro",
      titleCancelButton: data?.titleCancelButton || "Cancelar",
      iconCancelButton: data?.iconCancelButton || "far fa-times-circle fa-lg"
    };
  }

  closeDialog(){
    this.dialogRef.close();
  }
}
